module.exports = __webpack_public_path__ + "r-v3/img/ml_64_00.26c8ef5d.jpg";